import React from "react";
import './HomeBanner.css'
import { HeaderLayoutDetail } from '../models';

type HomeBannerProps={
    bannerData:HeaderLayoutDetail[]
}

const HomeBanner: React.FC<HomeBannerProps> = ({ bannerData }) => {
    const bannerUrl = bannerData?.[0]?.elements?.logo_and_banner?.linkedItems?.[0]?.elements?.banner?.value?.[0]?.url;
    return (
      <div className="home-banner">
        {bannerUrl ? (
          <img src={bannerUrl} alt="Header" className="banner-image" />
        ) : (
          <></>
        )}
      </div>
    );
  };

export default HomeBanner;